/*
 * @Description: url 相关的工具集
 * @usage: 这里应该放置与 url 相关的、且与运行环境（浏览器或服务端）无关的工具集，而且不能引入 import.meta
 * @Author: fiveonelei
 * @Date: 2022-01-18 15:59:40
 * @FilePath: /app-monorepo-projects/packages/app-share/src/utils/no-import-meta/url.ts
 */
import { IHashMap } from '@/types/data';

export interface IUrlParsedObject {
  hash: string;
  params: Record<string, string>;
}

export function fixHttps(url: string) {
  if (typeof url !== 'string') return '';
  try {
    return url.replace(/^https?:/, '');
  } catch (err) {
    return url;
  }
}

/**
 * 解析 url
 *
 * @export
 * @param {string} url
 * @return {*}  {(IUrlParsedObject | null)}
 */
export function parseUrl(url: string): IUrlParsedObject | null {
  if (typeof url !== 'string') return null;

  const [beforeHash = '', hash = ''] = url.split('#');
  const search = beforeHash.split('?')[1] ?? '';
  const segs = search.split('&');
  const params = segs.reduce((oriSum: Record<string, string>, seg) => {
    const sum = oriSum;
    if (!seg) return sum;

    let value = '';
    const [oriKey, oriVal] = seg.split('=');
    if (!oriKey) return sum;

    const key = decodeURIComponent(oriKey);
    if (!oriVal) {
      value = oriVal;
    } else {
      value = decodeURIComponent(oriVal);
    }
    sum[key] = value;
    return sum;
  }, {});

  return {
    hash,
    params,
  };
}

/**
 * 以对象形式获取 url 的查询参数对
 *
 * @export
 * @param {string} [url='']
 * @return {*}  {IUrlParsedObject['params']}
 */
export function getQueryObj(url = ''): IUrlParsedObject['params'] {
  return parseUrl(url)?.params || {};
}

/**
 * @description: 将对象转化为url的查询参数对
 * @param {IHashMap} obj
 * @param {*} sep
 * @param {*} eq
 * @return {*}
 */
export function queryStringify(obj: IHashMap, sep = '&', eq = '=') {
  // 过滤掉value为null或undefined的情况
  const keys = Object.keys(obj).filter(key => [null, undefined].indexOf(obj[key]) < 0);
  return keys.reduce((prev: string[], cur) => {
    const value = obj[cur];
    if (Array.isArray(value)) {
      value.forEach(val => prev.push([encodeURIComponent(cur), encodeURIComponent(val)].join(eq)));
    } else {
      prev.push([encodeURIComponent(cur), encodeURIComponent(value)].join(eq));
    }
    return prev;
  }, [])
    .join(sep);
}
